const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/teams/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import i18n from '@/lib/translations/i18n';
import { compactPicklistFilterSchema } from '@/lib/zod-schemas/common/compactFilterSchemas';
const teamsSearchSchema = z.object({
  roleId: compactPicklistFilterSchema
});
export const Route = createFileRoute('/(app)/org/$org/teams/')({
  validateSearch: zodValidator(teamsSearchSchema),
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  staticData: {
    topNav: {
      title: i18n.t('common.teams')
    }
  }
});